import { LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import React, { useEffect, useState } from 'react';

import { Container } from './FollowupList.styled';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import CustomTableSortLabel from '../../components/custom-table-sort-label/CustomTableSortLabel';
import CustomTablePagination from '../../components/custom-table-pagination/CustomTablePagination';
import IMedicalCertificate from '../../interfaces/IMedicalCertificate';
import { getTimeQuanitity } from './followupUtil';
import { useMedicalCertificateService } from '../../hooks/services/useMedicalCertificateService';
import moment from 'moment';

interface IProps {
  employeeId: string;
  /** Quando falso, o CID e a descrição do histórico ficam mascarados */
  seeCID: boolean;
}

const FollowupLastDocuments = (props: IProps) => {
  const [totalRows, setTotalRows] = useState(0);
  const [medicalCertificates, setMedicalCertificates] = useState<IMedicalCertificate[]>();
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('asc');
  const [orderField, setOrderField] = useState<string>('description');
  const [loading, setLoading] = useState(false);

  const request = useMedicalCertificateService();
  const toastr = useToastrVanila();

  const headers = [
    { field: 'documentDate', label: 'Data do documento' },
    { field: 'timeQuantity', label: 'Tempo de afastamento' },
    { field: 'diseaseClassifications_code', label: 'CID' },
    { field: 'diseaseClassifications_description', label: 'Descrição CID' },
  ];

  const listMedicalCertificate = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    orderDirection: 'asc' | 'desc',
  ) => {
    setLoading(true);

    await request
      .listForFollowup(perPage, currentPage + 1, orderField, orderDirection, {
        employeeId: props.employeeId,
        status: ['APPROVED'],
        initialDate: moment().subtract(60, 'days').format('yyyy-MM-DD'),
        finalDate: moment().format('yyyy-MM-DD'),
        statusIntegration: 'TODOS',
      })
      .then(result => {
        setMedicalCertificates([...result?.data]);
        setTotalRows(result.totalRows);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        toastr.error(error.message);
      });
  };
  useEffect(() => {
    const orderField = 'documentDate';
    const orderDirection = 'desc';
    listMedicalCertificate(perPage, currentPage, orderField, orderDirection);
  }, []);

  const getDiseaseClassifitation = (medicalCertificate: IMedicalCertificate): { code: string; description: string } => {
    const diseaseClassification =
      medicalCertificate.diseaseClassifications && medicalCertificate.diseaseClassifications[0];
    if (diseaseClassification?.code && diseaseClassification?.description) {
      return { code: diseaseClassification.code, description: diseaseClassification.description };
    }
    return { code: '', description: '' };
  };

  // Gestor sem permissão de ver CID enxerga apenas a máscara
  const maskCID = (value: string): string => (value && !props.seeCID ? '***' : value);

  return (
    <Container>
      <TableContainer>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              {headers.map(header => {
                return (
                  <CustomTableSortLabel
                    key={header.field}
                    perPage={perPage}
                    currentPage={currentPage}
                    orderField={orderField}
                    field={header.field}
                    label={header.label}
                    handleRequest={listMedicalCertificate}
                    direction={orderDirection}
                    setField={setOrderField}
                    setDirection={setOrderDirection}
                  />
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {medicalCertificates &&
              medicalCertificates.map(medicalCertificate => {
                return (
                  <TableRow key={medicalCertificate.id} hover={true}>
                    <TableCell>{moment(medicalCertificate.documentDate).format('DD/MM/yyyy')}</TableCell>
                    <TableCell>{getTimeQuanitity(medicalCertificate)}</TableCell>
                    <TableCell>{maskCID(getDiseaseClassifitation(medicalCertificate).code)}</TableCell>
                    <TableCell>{maskCID(getDiseaseClassifitation(medicalCertificate).description)}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomTablePagination
        totalRows={totalRows}
        currentPage={currentPage}
        perPage={perPage}
        handleRequest={listMedicalCertificate}
        setPerPage={setPerPage}
        setCurrentPage={setCurrentPage}
        orderField={orderField}
        orderDirection={orderDirection}
      />
    </Container>
  );
};

export default FollowupLastDocuments;
